const pageNameKey = "blueprintStateInfoBannerDataAcquisitionSummaryWrapper";

export const blueprintStateInfoBannerDataAcquisitionSummaryWrapperEn = {
  [pageNameKey]: {
    polling: "Polling",
    pollingIconAltText: "Polling Icon",
    monitoring: "Monitoring",
    monitoringIconAltText: "Monitoring Icon",
  },
};

export const blueprintStateInfoBannerDataAcquisitionSummaryWrapperPtBr = {
  [pageNameKey]: {
    polling: "Votação",
    pollingIconAltText: "Ícone de pesquisa",
    monitoring: "Monitoramento",
    monitoringIconAltText: "Ícone de monitoramento",
  },
};

export const blueprintStateInfoBannerDataAcquisitionSummaryWrapperDe = {
  [pageNameKey]: {
    polling: "Polling",
    pollingIconAltText: "Polling-Symbol",
    monitoring: "Monitoring",
    monitoringIconAltText: "Monitoring-Symbol",
  },
};

export const blueprintStateInfoBannerDataAcquisitionSummaryWrapperZhHans = {
  [pageNameKey]: {
    polling: "轮询",
    pollingIconAltText: "轮询图标",
    monitoring: "监控",
    monitoringIconAltText: "监控图标",
  },
};

export const blueprintStateInfoBannerDataAcquisitionSummaryWrapperIt = {
  [pageNameKey]: {
    polling: "Polling",
    pollingIconAltText: "Icona Polling",
    monitoring: "Monitoraggio",
    monitoringIconAltText: "Icona Monitoraggio",
  },
};

export const blueprintStateInfoBannerDataAcquisitionSummaryWrapperEs = {
  [pageNameKey]: {
    polling: "Sondeo",
    pollingIconAltText: "Icono de sondeo",
    monitoring: "Monitoreo",
    monitoringIconAltText: "Icono de monitoreo",
  },
};

export const blueprintStateInfoBannerDataAcquisitionSummaryWrapperNl = {
  [pageNameKey]: {
    monitoring: "Monitoring",
    monitoringIconAltText: "Monitoring-pictogram",
    polling: "Polling",
    pollingIconAltText: "Polling-pictogram",
  },
};

export const blueprintStateInfoBannerDataAcquisitionSummaryWrapperTr = {
  [pageNameKey]: {
    monitoring: "İzleme",
    monitoringIconAltText: "İzleme Simgesi",
    polling: "Oylama",
    pollingIconAltText: "Oylama Simgesi",
  },
};
